<template>
	<div>
		<ui-box :form="refs.blackoutDatesForm" :eager="!!product.id" new-forms>
			<form-subsection v-if="showTitle" title="Redemption Blackout Dates">
				If you need to limit when this can not be redeemed, add date ranges here.
			</form-subsection>

			<v-row>
				<v-col>
					<v-switch
							v-model="showDates"
							class="mb-2 mt-0"
							dense
							:disabled="showDates"
							hide-details="auto"
							inset
							label="Add blackout dates"
							@change="addNewBlackoutDate()"
					></v-switch>
				</v-col>
			</v-row>
			<!-- Date Rows -->
			<v-row
				v-for="(item, index) in product.redemption_blackout_dates"
				:key="index"
				class="mt-2"
			>
				<v-col cols="5">
					<bw-date-time-picker
							v-model="item.start_date"
							class="rounded-lg"
							label="Blackout Start"
							:required="true"
							:rules="[v => !!v || 'Start date is required.']"
							:tz="timezone"
							withTime
							@input="validateDates(index)"
					></bw-date-time-picker>
				</v-col>
				<v-col cols="5">
					<bw-date-time-picker
							:ref="'blackoutEndDate-' + index"
							v-model="item.end_date"
							class="rounded-lg"
							label="Blackout End"
							:required="true"
							:rules="[
								v => validateEndDate(index) || 'End date must be after start date',
								v => !!v || 'End date is required.'
							]"
							:tz="timezone"
							withTime
					></bw-date-time-picker>
				</v-col>
				<v-col cols="2" class="d-flex align-center range-controls">
					<v-btn
							class="rounded-lg mr-2"
							color="error"
							depressed
							outlined
							small
							@click="deleteBlackoutDate(index)"
					>
						<v-icon>mdi-minus</v-icon>
					</v-btn>
					<v-btn
							class="rounded-lg"
							color="secondary"
							depressed
							outlined
							small
							@click="addNewBlackoutDate(index)"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</ui-box>
	</div>
</template>

<script>
export default {
	props: {
		product: {
			type: Object,
			required: true
		},
		refs: {
			type: Object,
			required: true
		},
		showTitle: {
			type: Boolean,
			default: true
		},
		timezone: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			showDates: false
		}
	},
	mounted() {
		if(!this.product.redemption_blackout_dates) {
			this.product.redemption_blackout_dates = [];
		}
		this.product.redemption_blackout_dates.forEach((item, index) => {
			const value = this.product.redemption_blackout_dates[index].end_date;
			this.product.redemption_blackout_dates[index].end_date = '';
			this.$nextTick(() => {
				this.product.redemption_blackout_dates[index].end_date = value;
				this.$nextTick(() => this.validateDates(index));
			});
		});
		this.showDates = this.product.redemption_blackout_dates.length > 0;
	},
	methods: {
		addNewBlackoutDate(position = -1) {
			const range = { start_date: '', end_date: '' };

			this.product.redemption_blackout_dates.splice(position + 1, 0, range);
		},
		deleteBlackoutDate(index) {
			const { product: { redemption_blackout_dates: dates} } = this;
			dates.splice(index, 1);
			if (dates.length === 0) {
				this.showDates = false;
			}
		},
		validateDates(index) {
			this.$nextTick(() => {
				const ref = this.$refs['blackoutEndDate-' + index]?.[0];
				if (ref && typeof ref.validate === 'function') {
					ref.validate();
				}
			});
		},
		validateEndDate(i) {
			const {
				start_date: startDate,
				end_date: endDate
			} = this.product.redemption_blackout_dates[i];

			return !endDate || moment(endDate).isAfter(startDate);
		}
	}
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--icon):not(.v-btn--fab):not(.icon-only).v-size--small 
{
	height: 40px;
	& > .v-btn__content > .v-icon:first-child {
		margin-left: 0;
		margin-right: 0;
	}
}
</style>
